import {
  BatchSpanProcessor,
  WebTracerProvider
} from "@opentelemetry/sdk-trace-web";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { SemanticResourceAttributes } from "@opentelemetry/semantic-conventions";
import { Resource } from "@opentelemetry/resources";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { trace, SpanStatusCode } from "@opentelemetry/api";
import { UserInteractionInstrumentation } from "@opentelemetry/instrumentation-user-interaction";
import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
const serviceName = "dev-ec-spot-ui2";

const envList = [
  "localhost",
  "dev"
  // "acc", "ref", "eclear-solutions.com"
];

let enableOTEL = false;

for (const keyword of envList) {
  if (window.location.host.includes(keyword)) {
    enableOTEL = true;
    break;
  }
}

const collectorOptions = {
  url: "https://otel-col.eclear-solutions.com/",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  }
};

const providerConfig = {
  resource: new Resource({
    [SemanticResourceAttributes.SERVICE_NAME]: serviceName
  })
};

const provider = new WebTracerProvider(providerConfig);

function addSessionIdToSpan(span) {
  const sessionId = localStorage.getItem("sessionId");
  if (sessionId) {
    span.setAttribute("sessionId", sessionId);
  }
}

function recordError(error, isUnhandledRejection = false) {
  const tracer = provider.getTracer(serviceName);
  let span = trace.getActiveSpan();

  if (!span || span.isRecording() === false) {
    const spanName = isUnhandledRejection
      ? "Crash: Unhandled Promise Rejection"
      : "Crash: Uncaught Exception";
    span = tracer.startSpan(spanName, {
      attributes: {
        "error.type": error.name || "UnknownError",
        "error.message": error.message || "No message provided",
        "crash.source": isUnhandledRejection
          ? "Promise Rejection"
          : "Global Exception"
      }
    });
  }
  span.recordException(error);
  span.setStatus({
    code: SpanStatusCode.ERROR,
    message: error.message || "App Crash"
  });
  addSessionIdToSpan(span);
  span.end();
}

if (enableOTEL) {
  provider.addSpanProcessor(
    new BatchSpanProcessor(new OTLPTraceExporter(collectorOptions))
  );

  provider.register({
    contextManager: new ZoneContextManager()
  });

  registerInstrumentations({
    instrumentations: [
      new UserInteractionInstrumentation({
        enabled: true,
        eventNames: ["click"],
        listenerHook: (span) => {
          addSessionIdToSpan(span);
        }
      }),
      new DocumentLoadInstrumentation({ enabled: false })
    ],
    tracerProvider: provider
  });
  window.addEventListener("error", (event) => {
    const error =
      event.error || new Error(event.message || "Unspecified Error");
    recordError(error, false);
  });

  window.addEventListener("unhandledrejection", (event) => {
    recordError(event.reason, true);
  });
}

export const tracer = provider.getTracer(serviceName);

export default function TraceProvider({ children }) {
  return <>{children}</>;
}
